//线性映射
function mapValue(value, inMin, inMax, outMin, outMax) {
    return (value - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
}

let controller1 = new ScrollMagic.Controller();

//section1
var box2_title=document.getElementsByClassName('box2_title');
let scene1 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.factory_box1', 
        triggerHook: "0",
        duration:1000
})
if(window.innerWidth>750){
    scene1.setPin('.factory_box1');
    scene1.on("progress", function (event) {
        var index=event.progress.toFixed(3) * 100;
        if(index<60){
            $('.factory_box1 video').css({width:`${mapValue(index,0,60,45,100)}%`,borderRadius:`${mapValue(index,0,60,1,0)}rem`,bottom:`${mapValue(index,0,60,10,0)}%`})
        }else{
            $('.factory_box1 video').css({width:`100%`,borderRadius:'0',bottom:'0'})
        }
        if(index>30){
            $('.factory_box1 .box1_title').css({transform:`translateY(-15rem)`})
        }else{
            $('.factory_box1 .box1_title').css({transform:`translateY(0)`})
        }
    })
}

//secton2
let scene2 = new ScrollMagic.Scene({
        offset: 200,
        triggerElement: '.box2', 
        triggerHook: "onenter",
        duration:0,
})
scene2.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    $('.box2_img1').css({transform:'rotate(22deg) translate(0,0)',opacity:'1'})
    $('.box2_img2').css({transform:'rotate(40deg) translate(0,0)',opacity:'1'})
    if(index1<2){
        $('.box2_img1').css({transform:'rotate(22deg) translate(-5rem,14rem)',opacity:'0'})
        $('.box2_img2').css({transform:'rotate(40deg) translate(0rem, 14rem)',opacity:'0'})
    }
})

controller1.addScene([scene1,scene2]); 

$('.box3_item').hover(function(){
    $(this).find('div').css({zIndex:'1'})
},function(){
    $(this).find('div').css({zIndex:'-1'})
})